import { DatePicker, Select, Option, CheckboxGroup, CheckboxButton } from 'element-ui';
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue';

export default {
    name: 'ClubStandardListFilter',
    props: {
        filter: Object,
        blockStatuses: Array,
        standardTypes: Array,
        years: Array
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
        'medal-decider': MedalDecider
    },
    watch: {
        blockStatus: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.blockStatus = this.blockStatus;
                this.$emit("update:filter", filter);
            }
        },
        standardType: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.standardType = this.standardType;
                this.$emit("update:filter", filter);
            }
        },
        year: {
            immediate: true,
            handler(newVal, oldVal) {
                let filter = { ...this.filter };
                filter.year = this.year;
                this.$emit("update:filter", filter);
            }
        },
        perPage: {
            immediate: true,
            handler() {
                var options = { ...this.filter.options };
                var filter = { ...this.filter };

                filter.options = options;
                filter.options.perPage = this.perPage;
                this.$emit("update:filter", filter);
            }
        },
    },
    data() {
        return {
            isProcessing: false,
            perPage: 5,
            perPageOptions: [5, 10, 25, 50, 100],
            blockStatus: null,
            standardType: null,
            clubName: null,
            year: null
        }
    },
    computed: {
    },
    methods: {
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        clubNameChange() {
            let filter = { ...this.filter };
            filter.clubName = this.clubName;
            this.$emit("update:filter", filter);
        }
    },
    mounted() {
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-standards/filter-bar/filter-bar.js